module.exports = __webpack_public_path__ + "static/images/no-banner.a53d2fb.jpg";